import React, { useState, useEffect, useRef} from "react";

import { Link, useNavigate } from "react-router-dom";
/// Scroll
import { Dropdown } from "react-bootstrap";
import LogoutPage from "./Logout";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../../utils/utils";
import { formatNotificationTime, getNotificationIcon, getNotificationRedirectUrl } from "../../../utils/notificationUtils";
import { showErrorToast, showSuccessToast } from "../../components/PluginsMenu/Toastr/Toastr";
import { useGetUserNotificationsQuery, useMarkAllNotificationsAsReadMutation, useMarkNotificationAsReadMutation } from "../../../store/services/NotificationService";
import { useGetTutorNotificationsQuery } from "../../../store/services/tutor/DetailsService";
import { useGetAllAdminNotificationsQuery } from "../../../store/services/admin/UserService";

// Import images (or use base path)
import profile from "../../../images/no_user_placeholder.png";

const Header = () => {
  const navigate = useNavigate();
  const { role, currentUser } = useSelector((state) => state.auth);
  const [skip, setSkip] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const take = 5;

  const isTutor = role?.toLowerCase() === "tutor";
  const isAdmin = role?.toLowerCase() === "admin";
  const isStudent = role?.toLowerCase() === "student";

  const { data: userData, isLoading: userLoading, error: userError } = useGetUserNotificationsQuery(
    { skip, take }, { skip: !isStudent });
  
  const { data: tutorData, isLoading: tutorLoading, error: tutorError } = useGetTutorNotificationsQuery(
    { skip, take }, { skip: !isTutor });

  const { data: adminData, isLoading: adminLoading, error: adminError } = useGetAllAdminNotificationsQuery(
    { pageNumber: 1, pageSize: 10 }, { skip: !isAdmin });

  const [markAsRead] = useMarkNotificationAsReadMutation();
  const [markAllAsRead] = useMarkAllNotificationsAsReadMutation();
  
  const isLoading = isTutor ? tutorLoading : isAdmin ? adminLoading : userLoading;
  const error = isTutor ? tutorError : isAdmin ? adminError : userError;
  const apiData = isTutor ? tutorData : isAdmin ? adminData : userData;
  
  const notificationsList = Array.isArray(apiData?.data) ? apiData.data 
    : apiData?.data?.notifications || [];

  useEffect(() => {
    if (notificationsList) {
      if (skip === 0) {
        setNotifications(notificationsList);
      } else {
        setNotifications((prev) => [...prev, ...notificationsList]);
      }
    }
  }, [apiData]);

  const [headerFix, setheaderFix] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setheaderFix(window.scrollY > 50);
    });
  }, []);

  const handleSeeMore = async () => {
    try {
      setLoadingMore(true);
      setSkip((prev) => prev + take);
    } finally {
      setTimeout(() => setLoadingMore(false), 600);
    }
  };

  const handleNotificationClick = async (notification) => {
    try {
      // Mark as read first
      if (!notification.isRead) {
        await markAsRead(notification.id).unwrap();
        setNotifications((prev) => prev.map((n) => 
          n.id === notification.id ? { ...n, isRead: true } : n
        ));
      }
      
      // Close dropdown
      setShowNotifications(false);
      
      // Then navigate after a small delay to ensure dropdown closes
      setTimeout(() => {
        const redirectUrl = getNotificationRedirectUrl(notification, role);
        if (redirectUrl) {
          navigate(redirectUrl);
        }
      }, 100);
    } catch (err) {
      console.error("Failed to handle notification click:", err);
      showErrorToast("Something went wrong");
    }
  };

  const handleMarkAsRead = async (notificationId, e) => {
    e.stopPropagation(); // Prevent navigation when clicking mark as read
    
    try {
      const response = await markAsRead(notificationId).unwrap();
      if (response.succeeded && !response.errors?.length) {
        showSuccessToast(response.data.message);
        setNotifications((prev) => prev.map((notification) => 
          notification.id === notificationId ? { ...notification, isRead: true } : notification
        ));
      } else {
        showErrorToast("Failed to mark notification as read");
      }
    } catch (err) {
      console.error("Failed to mark notification as read:", err);
      showErrorToast("Something went wrong while marking as read");
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      const response = await markAllAsRead(currentUser.id).unwrap();

      if (response.succeeded && !response.errors?.length) {
        showSuccessToast(response.data.message);
        setNotifications((prev) =>
          prev.map((notification) => ({ ...notification, isRead: true }))
        )} else {
        showErrorToast("Failed to mark all notifications as read");
      }
    } catch (err) {
      console.error("Failed to mark all notifications as read:", err);
      showErrorToast("Something went wrong while marking all as read");
    }
  };

  // const { background, changeBackground } = useContext(ThemeContext);
  // const handleThemeMode = () => {
  //     if (background.value === 'dark') {
  //         changeBackground({ value: "light", label: "Light" });
  //     } else {
  //         changeBackground({ value: "dark", label: "Dark" });
  //     }
  // }
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName.includes("app")
    ? filterName.filter((f) => f !== "app")
    : filterName.includes("ui")
    ? filterName.filter((f) => f !== "ui")
    : filterName.includes("uc")
    ? filterName.filter((f) => f !== "uc")
    : filterName.includes("basic")
    ? filterName.filter((f) => f !== "basic")
    : filterName.includes("jquery")
    ? filterName.filter((f) => f !== "jquery")
    : filterName.includes("table")
    ? filterName.filter((f) => f !== "table")
    : filterName.includes("page")
    ? filterName.filter((f) => f !== "page")
    : filterName.includes("email")
    ? filterName.filter((f) => f !== "email")
    : filterName.includes("ecom")
    ? filterName.filter((f) => f !== "ecom")
    : filterName.includes("chart")
    ? filterName.filter((f) => f !== "chart")
    : filterName.includes("editor")
    ? filterName.filter((f) => f !== "editor")
    : filterName;

  const hasUnreadNotifications = notifications.some((n) => !n.isRead);

  return (
    <div className={`header ${headerFix ? "sticky" : ""}`}>
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
              >
                {finalName.join(" ").length === 0
                  ? "Dashboard"
                  : finalName.join(" ") === "dashboard dark"
                  ? "Dashboard"
                  : finalName.join(" ")}
              </div>
            </div>
            <ul className="navbar-nav header-right">
              <Dropdown
                as="li"
                className={`nav-item notification_dropdown ${hasUnreadNotifications ? " bell-icon" : ""}`}
                show={showNotifications}
                onToggle={(isOpen) => setShowNotifications(isOpen)}
              >
                <Dropdown.Toggle
                  className="nav-link i-false c-pointer"
                  variant=""
                  as="a"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.3677 18.9391V9.86768C25.3677 4.70215 21.1655 0.5 16 0.5C10.8345 0.5 6.63232 4.70215 6.63232 9.86768V18.9397C4.96704 19.4224 3.73828 20.9544 3.73828 22.8374C3.73828 25.0386 5.5293 26.8296 7.73096 26.8296H11.377V26.877C11.377 29.4263 13.4507 31.5 16 31.5C18.5493 31.5 20.6231 29.4263 20.6231 26.8769V26.8296H24.2691C26.4707 26.8296 28.2617 25.0386 28.2617 22.7583C28.2617 20.9406 27.033 19.4198 25.3677 18.9391ZM9.63232 9.86768C9.63232 6.35645 12.4888 3.5 16 3.5C19.5112 3.5 22.3677 6.35645 22.3677 9.86768V18.7661H9.63232V9.86768ZM17.6231 26.8769C17.6231 27.772 16.895 28.5 16 28.5C15.105 28.5 14.377 27.772 14.377 26.8769V26.8296H17.623V26.8769H17.6231ZM24.269 23.8296H7.73096C7.1836 23.8296 6.73828 23.3843 6.73828 22.7583C6.73828 22.2114 7.18359 21.7661 7.73096 21.7661H24.2691C24.8164 21.7661 25.2617 22.2114 25.2617 22.8374C25.2617 23.3843 24.8164 23.8296 24.269 23.8296Z"
                      fill="#A098AE"
                    />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  align="end"
                  className="dropdown-menu mt-2 dropdown-menu-end of-visible"
                  aria-labelledby="notification-dropdown"
                >
                  <div className="dropdown-header d-flex justify-content-between align-items-center">
                    <h4 className="title mb-0">Notification</h4>
                    {hasUnreadNotifications && (
                      <div className="d-flex align-items-center h6 mb-0">
                        <Link className=" p-2 btn btn-icon" onClick={handleMarkAllAsRead}
                          data-bs-toggle="tooltip" data-bs-placement="top" title="Mark all as read" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                              className="icon icon-tabler icon-tabler-mail-opened">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 9l9 6l9 -6l-9 -6l-9 6" />
                                <path d="M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10" />
                                <path d="M3 19l6 -6" />
                                <path d="M15 13l6 6" />
                            </svg>
                        </Link>
                      </div>
                    )}
                  </div>
                  <div
                    id="DZ_W_Notification1"
                    className="widget-media dlab-scroll py-3 px-0"
                    style={{ height: "380px" }}
                  >
                    <ul className="timeline">
                      {isLoading ? (
                        <li>
                          <div className="timeline-panel">
                            <div className="media-body text-center">
                              <div className="spinner-border" role="status"></div>
                            </div>
                          </div>
                        </li>
                      ) : error ? (
                        <li>
                          <div className="timeline-panel">
                            <div className="media-body">
                              <h6 className="mb-1 text-center text-danger">Failed to load notifications</h6>
                            </div>
                          </div>
                        </li>
                      ) : notifications?.length > 0 ? (
                        notifications.map((notification) => (
                          <li 
                            key={notification.id} 
                            onClick={() => handleNotificationClick(notification)}
                            style={{ cursor: 'pointer' }} 
                            className={!notification.isRead ? "bg-light" : ""}
                          >
                            <div className="timeline-panel pb-3">
                              <div className="media-body">
                                <div className="d-flex align-items-start gap-3">
                                  {/* Notification Icon */}
                                  <div className="flex-shrink-0">
                                    <img 
                                      src={getNotificationIcon(notification.notificationType)}
                                      alt={notification.notificationType}
                                      className="rounded-circle"
                                      style={{ 
                                        width: '36px', 
                                        height: '36px',
                                        //objectFit: 'contain',
                                        padding: '4px',
                                        //backgroundColor: '#f8f9fa',
                                        //border: '1px solid #e9ecef'
                                      }}
                                      onError={(e) => {
                                        e.target.src = '../images/ic_hourglass_vec.png';
                                      }}
                                    />
                                  </div>
                                  
                                  {/* Notification Content */}
                                  <div className="flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <p className="mb-1 text-dark" style={{ fontSize: '0.875rem', lineHeight: '1.3' }}>
                                          {notification.description}
                                        </p>
                                        <small className="text-muted">
                                          {formatNotificationTime(notification.createdDate)}
                                        </small>
                                      </div>
                                      
                                      {/* Mark as read button (only for unread) */}
                                      {!notification.isRead && (
                                        <button
                                          onClick={(e) => handleMarkAsRead(notification.id, e)}
                                          className="btn btn-sm btn-link p-0 ms-2"
                                          title="Mark as read"
                                        >
                                          <span 
                                            style={{ 
                                              width: '8px', 
                                              height: '8px', 
                                              backgroundColor: '#366A57', 
                                              borderRadius: '50%',
                                              display: 'inline-block'
                                            }}
                                          ></span>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li>
                          <div className="timeline-panel">
                            <div className="media-body text-center py-4">
                              <i className="fas fa-bell-slash text-muted" style={{ fontSize: '2rem' }}></i>
                              <h6 className="mb-1 mt-2">No Notifications</h6>
                              <small className="text-muted">You're all caught up!</small>
                            </div>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>

                  {notificationsList?.length === take && (
                    <div className="d-flex justify-content-center border-top">
                      <button
                        className="all-notification bg-transparent border-0 py-2"
                        onClick={handleSeeMore}
                        disabled={loadingMore}
                      >
                        {loadingMore ? (
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center">
                            <span>See more notifications</span>
                            <i className="fas fa-chevron-down ms-2"></i>
                          </div>
                        )}
                      </button>
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>

              <li className="nav-item ">
                <Dropdown className="dropdown header-profile2">
                  <Dropdown.Toggle
                    variant=""
                    as="a"
                    className="nav-link i-false c-pointer ms-0"
                  >
                    <div className="header-info2 d-flex align-items-center">
                      <div className="d-flex align-items-center gap-2">
                        <div className="text-end">
                          <h4 className="mb-0">{currentUser?.fullName}</h4>
                          <span>{role}</span>
                        </div>
                        <img
                          src={currentUser?.imageUrl ? `${process.env.REACT_APP_IMAGE_PATH}${currentUser.imageUrl}` : profile}
                          alt="user-profile"
                        />
                        <svg 
                          xmlns="http://www.w3.org/2000/svg" 
                          width="12" 
                          height="12" 
                          fill="currentColor" 
                          className="bi bi-chevron-down"
                          viewBox="0 0 16 16"
                        >
                          <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                        </svg>
                      </div>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    align="end"
                    className="mt-1 dropdown-menu dropdown-menu-end"
                  >
                    <div className="card mb-0">
                      {/* <div className="card-body p-3">
                                                <Link to="profile" className="dropdown-item ai-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
                                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <polygon points="0 0 24 0 24 24 0 24" />
                                                            <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fillRule="nonzero" opacity="0.3" />
                                                            <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="var(--primary)" fillRule="nonzero" />
                                                        </g>
                                                    </svg>
                                                    <span className="ms-2">Profile</span>
                                                </Link>
                                                <Link to="preferences" className="dropdown-item ai-icon ">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
                                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24" />
                                                            <path d="M18.6225,9.75 L18.75,9.75 C19.9926407,9.75 21,10.7573593 21,12 C21,13.2426407 19.9926407,14.25 18.75,14.25 L18.6854912,14.249994 C18.4911876,14.250769 18.3158978,14.366855 18.2393549,14.5454486 C18.1556809,14.7351461 18.1942911,14.948087 18.3278301,15.0846699 L18.372535,15.129375 C18.7950334,15.5514036 19.03243,16.1240792 19.03243,16.72125 C19.03243,17.3184208 18.7950334,17.8910964 18.373125,18.312535 C17.9510964,18.7350334 17.3784208,18.97243 16.78125,18.97243 C16.1840792,18.97243 15.6114036,18.7350334 15.1896699,18.3128301 L15.1505513,18.2736469 C15.008087,18.1342911 14.7951461,18.0956809 14.6054486,18.1793549 C14.426855,18.2558978 14.310769,18.4311876 14.31,18.6225 L14.31,18.75 C14.31,19.9926407 13.3026407,21 12.06,21 C10.8173593,21 9.81,19.9926407 9.81,18.75 C9.80552409,18.4999185 9.67898539,18.3229986 9.44717599,18.2361469 C9.26485393,18.1556809 9.05191298,18.1942911 8.91533009,18.3278301 L8.870625,18.372535 C8.44859642,18.7950334 7.87592081,19.03243 7.27875,19.03243 C6.68157919,19.03243 6.10890358,18.7950334 5.68746499,18.373125 C5.26496665,17.9510964 5.02757002,17.3784208 5.02757002,16.78125 C5.02757002,16.1840792 5.26496665,15.6114036 5.68716991,15.1896699 L5.72635306,15.1505513 C5.86570889,15.008087 5.90431906,14.7951461 5.82064513,14.6054486 C5.74410223,14.426855 5.56881236,14.310769 5.3775,14.31 L5.25,14.31 C4.00735931,14.31 3,13.3026407 3,12.06 C3,10.8173593 4.00735931,9.81 5.25,9.81 C5.50008154,9.80552409 5.67700139,9.67898539 5.76385306,9.44717599 C5.84431906,9.26485393 5.80570889,9.05191298 5.67216991,8.91533009 L5.62746499,8.870625 C5.20496665,8.44859642 4.96757002,7.87592081 4.96757002,7.27875 C4.96757002,6.68157919 5.20496665,6.10890358 5.626875,5.68746499 C6.04890358,5.26496665 6.62157919,5.02757002 7.21875,5.02757002 C7.81592081,5.02757002 8.38859642,5.26496665 8.81033009,5.68716991 L8.84944872,5.72635306 C8.99191298,5.86570889 9.20485393,5.90431906 9.38717599,5.82385306 L9.49484664,5.80114977 C9.65041313,5.71688974 9.7492905,5.55401473 9.75,5.3775 L9.75,5.25 C9.75,4.00735931 10.7573593,3 12,3 C13.2426407,3 14.25,4.00735931 14.25,5.25 L14.249994,5.31450877 C14.250769,5.50881236 14.366855,5.68410223 14.552824,5.76385306 C14.7351461,5.84431906 14.948087,5.80570889 15.0846699,5.67216991 L15.129375,5.62746499 C15.5514036,5.20496665 16.1240792,4.96757002 16.72125,4.96757002 C17.3184208,4.96757002 17.8910964,5.20496665 18.312535,5.626875 C18.7350334,6.04890358 18.97243,6.62157919 18.97243,7.21875 C18.97243,7.81592081 18.7350334,8.38859642 18.3128301,8.81033009 L18.2736469,8.84944872 C18.1342911,8.99191298 18.0956809,9.20485393 18.1761469,9.38717599 L18.1988502,9.49484664 C18.2831103,9.65041313 18.4459853,9.7492905 18.6225,9.75 Z" fill="#000000" fillRule="nonzero" opacity="0.3" />
                                                            <path d="M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z" fill="#000000" />
                                                        </g>
                                                    </svg>
                                                    <span className="ms-2">Settings </span>
                                                </Link>
                                            </div> */}
                      <div className="text-center p-3">
                        <LogoutPage />
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;